import { backendServices } from 'common';

// @ts-expect-error
import pdfFile from './assets/pdfFile.png';
// @ts-expect-error
import csvFile from './assets/csvFile.png';
// @ts-expect-error
import txtFile from './assets/txtFile.png';
// @ts-expect-error
import printer from './assets/printer.jpg';
// @ts-expect-error
import invoice from './assets/invoice.jpg';
// @ts-expect-error
import send from './assets/send.jpg';
// @ts-expect-error
import complete from './assets/complete.jpg';
// @ts-expect-error
import receive from './assets/receive.jpg';
// @ts-expect-error
import dataConnection from './assets/dataConnection.jpg';

export function GuideIcon({ logo }: { logo: backendServices.ViewModels.SubmissionGuideLogo }) {
    switch (logo) {
        case backendServices.ViewModels.SubmissionGuideLogo.INVOICE:
            return <img src={invoice} alt="invoice icon" data-testid={`logo-${logo}`} />;
        case backendServices.ViewModels.SubmissionGuideLogo.DATA_CONNECTION:
            return <img src={dataConnection} alt="data connection icon" data-testid={`logo-${logo}`} />;
        case backendServices.ViewModels.SubmissionGuideLogo.PRINTER:
            return <img src={printer} alt="printer icon" data-testid={`logo-${logo}`} />;
        case backendServices.ViewModels.SubmissionGuideLogo.SEND:
            return <img src={send} alt="data connection icon" data-testid={`logo-${logo}`} />;
        case backendServices.ViewModels.SubmissionGuideLogo.COMPLETE:
            return <img src={complete} alt="data connection icon" data-testid={`logo-${logo}`} />;
        case backendServices.ViewModels.SubmissionGuideLogo.RECEIVE:
            return <img src={receive} alt="receive icon" data-testid={`logo-${logo}`} />;
        case backendServices.ViewModels.SubmissionGuideLogo.TXT:
            return (
                <img
                    src={txtFile}
                    alt="txt file icon"
                    style={{
                        maxWidth: '70px',
                    }}
                    data-testid={`logo-${logo}`}
                />
            );
        case backendServices.ViewModels.SubmissionGuideLogo.CSV:
            return (
                <img
                    src={csvFile}
                    alt="csv file icon"
                    style={{
                        maxWidth: '70px',
                    }}
                    data-testid={`logo-${logo}`}
                />
            );
        case backendServices.ViewModels.SubmissionGuideLogo.PDF:
            return (
                <img
                    src={pdfFile}
                    alt="pdf file icon"
                    style={{
                        maxWidth: '70px',
                    }}
                    data-testid={`logo-${logo}`}
                />
            );
        default:
            return null;
    }
}
